const myEventsList = [
  {
    title: "National Astronaut Day",
    start: new Date("2025-05-05T13:45:00-05:00"),
    end: new Date("2025-05-05T14:00:00-05:00"),
    color: "orange",
  },
  {
    title: "National Police Week",
    start: new Date("2025-05-11T01:00:00-05:00"),
    end: new Date("2025-05-17T23:59:00-05:00"),
  },
  {
    title: "Nurses Week",
    start: new Date("2025-05-18T13:45:00-05:00"),
    end: new Date("2025-05-24T14:00:00-05:00"),
  },
];

export default myEventsList;
